import { render, staticRenderFns } from "./competency-report.vue?vue&type=template&id=64b53e67"
import script from "./competency-report.ts?vue&type=script&lang=ts&external"
export * from "./competency-report.ts?vue&type=script&lang=ts&external"
import style0 from "./competency-report.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports